const BellIcon = ({ className, fill }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0001 1.0415C6.2869 1.0415 3.27332 4.03443 3.27329 7.73064C3.27322 8.59038 3.2154 9.23928 2.81901 9.8225C2.76389 9.90241 2.69077 10.0025 2.61086 10.1119C2.47207 10.3018 2.31281 10.5198 2.19203 10.7086C1.97885 11.0418 1.77058 11.4435 1.69898 11.9117C1.46538 13.439 2.54221 14.4279 3.61463 14.871C4.31172 15.159 5.05783 15.3939 5.83487 15.5756C5.82974 15.6621 5.83811 15.7508 5.86158 15.8391C6.34248 17.6486 8.02578 18.9584 10.0003 18.9584C11.9748 18.9584 13.6581 17.6486 14.139 15.8391C14.1625 15.7508 14.1708 15.662 14.1657 15.5755C14.9426 15.3938 15.6886 15.159 16.3855 14.871C17.4579 14.4279 18.5348 13.439 18.3012 11.9117C18.2296 11.4435 18.0213 11.0418 17.8081 10.7086C17.6874 10.5198 17.5281 10.3019 17.3894 10.1119C17.3095 10.0026 17.2363 9.90247 17.1812 9.82256C16.7848 9.23932 16.7269 8.59049 16.7269 7.73069C16.7269 4.03446 13.7133 1.0415 10.0001 1.0415ZM12.3395 15.8989C10.8005 16.089 9.20016 16.0891 7.66107 15.8989C8.08349 16.7157 8.96372 17.2917 10.0003 17.2917C11.0369 17.2917 11.9171 16.7157 12.3395 15.8989Z"
        fill={fill || "#888888"}
      />
    </svg>
  );
};

export default BellIcon;
